import React, {useState, useEffect} from "react"
import { CircularProgressbar } from "react-circular-progressbar"
import "react-circular-progressbar/dist/styles.css"
import { WithTip } from 'components/tooltip/with-tip'
import styled from "styled-components"
import _ from "lodash"

import propertyService from "data/property"
import validationService from "data/validate"
import { getPropertyDetails } from "data/lib/property"
import { CalcStatus } from "data/interface/calc"
import { Colors } from "styles/app-styles"

const CalcIndicator = styled.div`
  width: 14px;
  height: 14px;
  margin-top: 0px;
  ${(props: {status: string}) => {
    if(props.status === CalcStatus.NOT_CALC) return (`
      background-color: ${Colors.blackPearl};
      border-radius: 50%;
      box-shadow: 0px 0px 1px 0px ${Colors.blackPearl};
    `)
    else if(props.status === CalcStatus.CALC_WITH_ERR) return (`
      background-color: ${Colors.colorWarning};
      border-radius: 50%;
      box-shadow: 0px 0px 1px 0px ${Colors.colorWarning};
    `)
    else if(props.status === CalcStatus.IN_PROCESS) return (`
      background-color: ${Colors.periwinkleGrey};
      border-radius: 50%;
      box-shadow: 0px 0px 1px 0px ${Colors.periwinkleGrey};
    `)
    else if(props.status === CalcStatus.CALCULATED) return (`
      background-color: ${Colors.colorSuccess};
      border-radius: 50%;
      box-shadow: 0px 0px 1px 0px ${Colors.colorSuccess};
    `)
    else if(props.status === CalcStatus.WARNING) return (`
      background-color: ${Colors.colorDanger};
      border-radius: 50%;
      box-shadow: 0px 0px 1px 0px ${Colors.colorDanger};
    `)
  }}
`

const RowCalcStatus = (props: {propertyId: number}) => {
  const [currentProp, setCurrentProp] = useState<object>({})
  let {calcDetail, calcStatus, errordetail, severe} = getPropertyDetails(currentProp)

  useEffect(() => {
    const propertySubscription = propertyService.stream().subscribe(data => {
      if(data.value.length) {
        const foundProperty = _.find(data.value, prop => prop.propertyid === props.propertyId)
        if(foundProperty) setCurrentProp(foundProperty)
      }
    })

    return function cleanup() {
      propertySubscription.unsubscribe()
    }
  }, [props.propertyId])

  const showValidationErrors = () => validationService.displayValidationErrors({errordetail, calcDetail})

  let indicator = (
    <WithTip position="bottom">
      <span>Not Calculated</span>
      <CalcIndicator status={CalcStatus.NOT_CALC} id="calcStatusContainer" />
    </WithTip>
  )
  if (calcStatus === CalcStatus.CALC_WITH_ERR || (errordetail !== null && (calcStatus !== CalcStatus.IN_PROCESS && calcStatus !== null))) {
    indicator = (
      <WithTip position="bottom">
        <span>Calculated with Warnings</span>
        <CalcIndicator status={CalcStatus.CALC_WITH_ERR} id="calcStatusContainer" />
      </WithTip>
    )
  } else if (errordetail !== null && calcStatus === null) {
    indicator = (
      <WithTip position="bottom">
        <span>Warning: Click to Review Inputs</span>
        <CalcIndicator status={CalcStatus.WARNING} id="calcStatusContainer" />
      </WithTip>
    )
  } else if (calcStatus === CalcStatus.CALCULATED) {
    indicator = (
      <WithTip position="bottom">
        <span>Calculated</span>
        <CalcIndicator status={CalcStatus.CALCULATED} id="calcStatusContainer" />
      </WithTip>
    )
  } else if (calcStatus === CalcStatus.IN_PROCESS) {
    const progress = Math.round(Math.max(0, +calcDetail.completePercent))
    indicator = (
      <WithTip position="bottom">
        <span>{`Calc in Process (${progress}%)`}</span>
        <div style={{width: "25px"}}>
          <CircularProgressbar value={progress} styles={{root:{paddingLeft: "8px", width: '20px', marginLeft: '3px'}}}/>
        </div>
      </WithTip>
    )
  }

  let content = (
    <div className="row-control" style={{paddingLeft: "15px", cursor: "pointer"}} onClick={() => showValidationErrors()}>
      {indicator}
    </div>
  )
  if(calcStatus === CalcStatus.IN_PROCESS) {
    content = (
      <div className="row-control" style={{paddingLeft: "5px"}}>
        {indicator}
      </div>
    )
  }

  return content
}

export default RowCalcStatus
